import React from 'react';
import { Alert, AlertTitle, Typography } from '@mui/material';
import t from '../../utils/renewalsTranslations';

export default function CoverageGapWarning({ gapDays }) {
  if (gapDays == null || gapDays <= 0) return null;
  const message = t('renewals.gap.message').replace('{{days}}', String(gapDays));
  return (
    <Alert severity="warning" sx={{ mt: 2 }}>
      <AlertTitle>{t('renewals.gap.warning')}</AlertTitle>
      <Typography variant="body2">{message}</Typography>
    </Alert>
  );
}
